import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  LoadingOutlined,
  PauseOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";

export default function ETag({ children }) {
  if (children === null) {
    return;
  }

  switch (children.toUpperCase()) {
    case "POSTED":
    case "ACTIVE":
    case "COMPLETED":
    case "APPROVED":
    case "SUCCESS":
    case "PASS":
    case "CONFIRMED":
    case "ENABLE":
    case "TRUE":
      return (
        <Tag icon={<CheckOutlined />} color="blue">
          {children}
        </Tag>
      );
    case "SUSPENDED":
    case "DECLINED":
    case "REJECTED":
    case "DELETED":
    case "VOID TIMEOUT":
    case "FALSE":
    case "DISABLE":
    case "CANCELLED":
      return (
        <Tag icon={<CloseOutlined />} color="red">
          {children}
        </Tag>
      );
    case "LOCKED":
      return (
        <Tag icon={<PauseOutlined />} color="yellow">
          {children}
        </Tag>
      );
    case "EXPIRED":
      return (
        <Tag icon={<ClockCircleOutlined />} color="yellow">
          {children}
        </Tag>
      );
    case "CREATED":
      return <Tag icon={<PlusCircleOutlined />}>{children}</Tag>;
    case "PROCESSING":
    case "AWAITING ACTIVATION":
    case "DRAFT":
      return <Tag icon={<LoadingOutlined />}>{children}</Tag>;
    default:
      return <Tag>{children}</Tag>;
  }
}
